import React, { useState, useEffect } from 'react';
import './TeamPublic.css';
import { NavLink, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import api from '@api'; // Instead of ../../../utils/api
import { useDomain } from '@useDomain';



function TeamPublic() {
  const [team, setTeam] = useState(null);
  const { id } = useParams();
  const { domain, slug } = useDomain();
  const [error, setError] = useState("");
  const [playersAttr, setPlayersAttr] = useState([])
  const [loading, setLoading] = useState(true); // 1. Add loading state

  const navigate = useNavigate();

  useEffect(() => {
    const getTeam = async () => {
      try {
        const response = await api.get(`/api/teamsv2/${id}`, {
          params: slug ? { slug } : { domain },
        });
        console.log(response)
        setTeam(response.data.team);
        const uniquePlayersMap = new Map();

        response.data.team.rosters.forEach(r => {
          const player = r.player;
          if (!uniquePlayersMap.has(player.id)) {
            uniquePlayersMap.set(player.id, {
              ...player,
              // ✅ Optional: clean duplicate attributeValues if needed
              attributeValues: Array.from(
                new Map(
                  player.attributeValues?.map(att => [att.attribute_id, att])
                ).values()
              ),
            });
          }
        });

        setPlayersAttr(Array.from(uniquePlayersMap.values()));


      } catch (error) {
        console.error("Error fetching team:", error.response?.data || error.message);
        setError("Failed to fetch team");
      } finally {
        setLoading(false); // 2. Stop loading after fetch (success or fail)
      }
    };
    getTeam();
  }, [id, domain]);

  // const uniqueAttributes = Array.from(
  //   new Set(playersAttr.flatMap((player) =>
  //     player.attributeValues
  //       .filter(att => att.attribute.is_visible !== false)
  //       .map(att => att.attribute.attribute_name)
  //   ))
  // );



  if (loading) return null;
  if (error) return <div>{error}</div>;

  return (
    <div className="teamPublic-container">
      <div className="teamPublic-banner">
        {team?.name}
      </div>
      <div className="teamPublic-games-container">
        <h4 className="teamPublic-games-title">SCHEDULE</h4>
        <table className="teamPublic-games-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Matchup</th>
              <th>Results</th>
            </tr>
          </thead>
          <tbody>
            {team?.games
              ?.slice()
              .sort((a, b) => new Date(a.date) - new Date(b.date))
              .map((game, index) => (
                <tr
                  key={index}
                  className="clickable-row"
                  onClick={() =>
                    navigate(
                      slug
                        ? `/${slug}/games/${game.id}`
                        : `/games/${game.id}`
                    )
                  }
                >
                  <td>
                    {new Date(game.date + "T00:00:00Z").toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                      timeZone: "UTC", // ✅ ensures it's interpreted correctly
                    })
                    }
                  </td>
                  <td>
                    {game.team1} vs {game.team2}
                  </td>
                  <td>
                    {game.score_team1} - {game.score_team2}
                  </td>
                </tr>
              ))}
          </tbody>

        </table>

      </div>

      <div className="teamPublic-players-container">
        <h4 className="teamPublic-players-title">ROSTER</h4>
        <table className="teamPublic-players-table">
          <thead>
            <tr>
              <th>Name</th>
              {/* {uniqueAttributes.map((attrName, index) => (
                <th key={index}>{attrName}</th>
              ))} */}
            </tr>
          </thead>
          <tbody>
            {playersAttr.length > 0 ? (
              playersAttr.map((player) => (
                <tr key={player.id}>
                  <td>
                    <NavLink to={slug ? `/${slug}/players/${player.id}` : `/players/${player.id}`} >
                      {player.firstName.trim()}
                    </NavLink>
                  </td>

                  {/* {uniqueAttributes.map((attrName, index) => {
                    const attributeValue = player.attributeValues.find(
                      (att) => att.attribute.attribute_name === attrName &&
                        att.attribute.is_visible !== false // ✅ filter again here
                    );
                    return (
                      <td key={index}>
                        {attributeValue && attributeValue.value.trim() !== "" ? attributeValue.value : "-"}
                      </td>
                    );
                  })} */}
                </tr>
              ))
            ) : (
              <tr>
                {/* <td colSpan={uniqueAttributes.length + 1} style={{ textAlign: "center" }}>
                  No players available
                </td> */}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TeamPublic;
